import React from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

import CsLineIcons from '../../cs-line-icons';
import NotificationItem from "./item";
import { read as readNotifications, readAll as readAllNotifications, get as getNotifications } from '../../actions/notifications';
import "./style.css";

class Notifications extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showing: props?.showing || false,
            items: props?.items || []
        }
    }

    componentDidMount() {
        this.props.getNotifications();
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.showing || false) !== (this.props?.showing || false)) {
            this.setState({
                showing: this.props.showing
            });
        }

        if (prevProps.items !== this.props.items) {
            this.setState({
                items: this.props.items || []
            });
        }
    }

    onToggle = (status, event) => {
        if (event?.stopPropagation) {
            event.preventDefault();
            event.stopPropagation();
        } else if (event?.originalEvent?.stopPropagation) {
            event.originalEvent.preventDefault();
            event.originalEvent.stopPropagation();
        }
        this.setState({
            showing: !this.state.showing
        })
    };

    NotificationsDropdownToggle = React.forwardRef(({ onClick, expanded = false }, ref) => {
            const count = this.state.items.length;
            return (
                <button
                    ref={ref}
                    type="button"
                    className="notification-button border-0 bg-transparent"
                    aria-label="Notifications"
                    aria-expanded={expanded}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onClick(e);
                    }}
                >
                    <div className="position-relative d-inline-flex">
                        <CsLineIcons icon="bell" size="18" />
                        {count ? <span className="position-absolute notification-dot rounded-xl" /> : null}
                    </div>
                </button>
            );
        });

    onRead = (id) => {
        if (!id) return;
        this.props.readNotifications(id);
    }

    onReadAll = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.readAllNotifications(this.state.items.map((item) => item.uuid));
    };

    onFooterClick = () => {
        this.setState({ showing: false });
    };

    NotificationsDropdownMenu = React.forwardRef(({ style, className, labeledBy }, ref) => {
            const { items } = this.state;
            const count = items.length;
            const caption = count === 1 ? "1 New notification" : `${count} New notifications`;

            return (
                <div ref={ref} style={style} className={`wide notification-dropdown ${className}`} aria-labelledby={labeledBy}>
                    <div className="notification-dropdown-header">
                        <div className="notification-dropdown-title">{count ? caption : "No new notifications"}</div>
                    </div>
                    <div className="notification-dropdown-body">
                        <button
                            type="button"
                            className="notification-dropdown-action"
                            onClick={this.onReadAll}
                            disabled={!count}
                        >
                            Set all as read
                        </button>
                        <div className="notification-dropdown-divider" />
                        {count ? (
                            <OverlayScrollbarsComponent
                                options={{
                                    scrollbars: { autoHide: 'leave', autoHideDelay: 600 },
                                    overflowBehavior: { x: 'hidden', y: 'scroll' },
                                }}
                                className="notification-scroll"
                            >
                                <ul className="notification-list list-unstyled">
                                    {items.map((item) =>
                                        <NotificationItem
                                            key={`notificationItem.${item.uuid}`}
                                            onRead={this.onRead}
                                            id={item.uuid}
                                            style={item.style}
                                            title={item.title}
                                            description={item.description}
                                            activeDate={item.activeDate}
                                        />
                                    )}
                                </ul>
                            </OverlayScrollbarsComponent>
                        ) : (
                            <div className="notification-empty">You're all caught up.</div>
                        )}
                        <Link to="/dashboard/notifications" className="notification-footer-link" onClick={this.onFooterClick}>
                            See all notifications
                        </Link>
                    </div>
                </div>
            );
        });

    render() {
        return (
            <Dropdown
                as="li"
                bsPrefix="list-inline-item notification-nav-item"
                onToggle={this.onToggle}
                show={this.state.showing}
                align="end"
            >
                <Dropdown.Toggle as={this.NotificationsDropdownToggle} />
                <Dropdown.Menu
                    as={this.NotificationsDropdownMenu}
                    popperConfig={{
                        modifiers: [
                            {
                                name: 'offset',
                                options: { offset: () => [0, 12] }
                            },
                        ],
                    }}
                />
            </Dropdown>
        )
    }
}

Notifications.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object,
    items: PropTypes.array,
    readNotifications: PropTypes.func.isRequired,
    readAllNotifications: PropTypes.func.isRequired,
    getNotifications: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth || {},
        profile: state.licensee?.profile || {},
        notification: state.notification || {},
        items: state.notification?.items || []
    });
};

export default connect(mapStateToProps, { readNotifications, readAllNotifications, getNotifications })(Notifications);
